module.exports = {
      id: "author-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#author",
      toString: function () {
        return this.url;
      }
    }